import { RequestStatusFields } from 'reducers/statuses';
import { RootState } from 'reduxInfra/shared';

export const getRequestStatus = <E = unknown>(state: RootState, id: string) =>
  state.statuses.requestStatuses[id] as RequestStatusFields<E> | undefined;
